/**
 * Admin-Übersichtsseite – Liste aller Mandanten sowie Einstieg in die globalen,
 * mandantenübergreifenden Stammdaten.
 * Erreichbar unter /admin (erfordert Permission admin:write).
 */
import React, { useState } from "react";
import { Container } from "@mui/material";
import PageTemplate from "../../layout/PageTemplate";
import OrgsSection from "./sections/OrgsSection";
import CreateOrgDialog from "./sections/CreateOrgDialog";
import AnlagentypStammdaten from "./sections/AnlagentypStammdaten";
import { useAdminOrgs } from "./hooks/useAdminOrgs";
import { AdminOrg } from "../../../services/api/admin";

const AdminOverviewPage: React.FC = () => {
  const { orgs, loading, error, reload } = useAdminOrgs();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const handleOrgCreated = (_org: AdminOrg) => {
    reload();
  };

  return (
    <PageTemplate isLoading={loading} error={error}>
      <Container maxWidth="xl">
        <OrgsSection
          orgs={orgs}
          onCreateClick={() => setCreateDialogOpen(true)}
        />

        {/*
          Mandantenübergreifende Stammdaten: Hersteller und ihre Modelle. Das Modell ist die
          Vorlage, aus der beim Hinzufügen einer Anlage ins Projekt kopiert wird.
        */}
        <AnlagentypStammdaten />

        <CreateOrgDialog
          open={createDialogOpen}
          onClose={() => setCreateDialogOpen(false)}
          onCreated={handleOrgCreated}
        />
      </Container>
    </PageTemplate>
  );
};

export default AdminOverviewPage;
